import React from "react";
import { NavLink } from "react-router-dom";

export default function PowerBITraining() {
  return (
    <section className="container page-top pt-10" style={{ paddingTop: "6rem" }}>
      <div className="container">
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h1 className="display-5 fw-bold text-primary">Business Intelligence with Microsoft Power BI</h1>
            <h5 className="text-muted">
              Unlock Data Insights to Make Smarter Decisions with Powerful Dashboards
            </h5>
            <hr className="w-25 mx-auto" />
          </div>
        </div>

        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <img
              src="https://img.freepik.com/free-vector/data-analysis-concept-illustration_114360-1263.jpg"
              alt="Power BI Dashboard"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-semibold">Transform Data into Actionable Intelligence</h2>
            <p>
              <strong>Bytlas Intelligence</strong> offers dynamic Power BI training and consulting to empower organizations with data visualization, reporting automation, and performance dashboards.
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ Power BI Desktop & Service Training</li>
              <li className="list-group-item">✅ Live Dashboards for Sales, HR, Finance</li>
              <li className="list-group-item">✅ Power Query, DAX & Custom Visuals</li>
              <li className="list-group-item">✅ Integration with Excel, SQL, and APIs</li>
            </ul>
          </div>
        </div>

        <div className="row my-5">
          <div className="col-md-6">
            <h3 className="text-secondary">Tailored for Every Team</h3>
            <p>
              Whether you're a data analyst, business executive, or report developer — our certified Power BI experts provide hands-on training that suits your role and goals.
            </p>
          </div>

          <div className="col-md-6">
            <h3 className="text-secondary">What You Gain</h3>
            <ul>
              <li>📊 Interactive, Real-Time Dashboards</li>
              <li>🔁 Automated Reporting Pipelines</li>
              <li>🔍 Advanced Analytics & KPIs</li>
              <li>🧠 Data Modeling & Scenario Building</li>
              <li>🏆 Corporate Training by Microsoft-Certified Trainers</li>
            </ul>
          </div>
        </div>

        <div className="text-center mt-4">
          <NavLink to="/contact" className="btn btn-danger px-4 py-2 rounded-pill fw-bold">
            Start Your Data Journey with Power BI
          </NavLink>
        </div>
      </div>
    </section>
  );
}
